import {
  GET_AFFILIATE_WITHDRAWALS,
  GET_AFFILIATE_WITHDRAWAL_STATS,
} from "./affiliateWithdraw.type";

const initialState = {
  withdrawals: [],
  stats: {
    pendingRequests: 0,
    approvedRequests: 0,
    rejectedRequests: 0,
    totalApprovedAmount: 0,
  },
};

const affiliateWithdrawReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AFFILIATE_WITHDRAWALS:
      return {
        ...state,
        withdrawals: action.payload,
      };
    case GET_AFFILIATE_WITHDRAWAL_STATS:
      return {
        ...state,
        stats: action.payload,
      };
    default:
      return state;
  }
};

export default affiliateWithdrawReducer;